export default "__VITE_ASSET__Bvn7Oh6i__"